import React from 'react'

export default function VisiGiftGiftHistory() {
  return (
    <div>VisiGiftGiftHistory</div>
  )
}
